/**
 * @Author: Zero
 * @Date: 2023-11-01 16:15:17
 * @Explain: 联系人 - 枚举信息
 */
/** 上传文件表头 */
export enum FileHeaderKeyEnum {
  /** 邮箱地址 - 中文 */
  EMAIL_ZH = '邮箱地址',
  /** 邮箱地址 - 英文 */
  EMAIL_EN = 'Email',
  /** 地区编码 - 中文 */
  LOCATION_CODE_ZH = '地区编码',
  /** 地区编码 - 英文 */
  LOCATION_CODE_EN = 'Location code',
  /** 语言编码 - 中文 */
  LANGUAGE_CODE_ZH = '语言编码',
  /** 语言编码 - 英文 */
  LANGUAGE_CODE_EN = 'Language code',
  /** 偏好 - 中文 */
  PREFERENCE_CODE_ZH = '偏好',
  /** 偏好 - 英文 */
  PREFERENCE_CODE_EN = 'Preferences',
  /** 标签 - 中文 */
  TAG_CODE_ZH = '标签',
  /** 标签 - 英文 */
  TAG_CODE_EN = 'Tags',
  /** WhatsApp - 中文 */
  WHATSAPP_ZH = 'WhatsApp',
  /** WhatsApp - 英文 */
  WHATSAPP_EN = 'WhatsApp',
}

// 上传文件表头 - 字段类型
export enum FileHeaderTypeEnum {
  /** 邮箱地址 */
  EMAIL = 'Email',
  /** WhatsApp */
  WHATSAPP = 'WhatsApp',
  /** 地点编码 */
  LOCATION = 'location code',
  /** 语言编码*/
  LANGUAGE = 'language code',
  /** 偏好编码*/
  PREFERENCE = 'Preference',
  /** 标签 - 英文 */
  TAG = 'Tag',
  /** 字符串 */
  STRING = 'string',
  /**数字 */
  NUMBER = 'number',
  /** 日期*/
  DATE = 'date',
}
export enum FileHeaderValueEnum {
  /** 邮箱地址 */
  EMAIL = 1,
  /** 邮箱地址 */
  WHATSAPP = 20,
  /** 地点编码 */
  LOCATION = 2,
  /** 语言编码*/
  LANGUAGE = 3,
  /** 偏好*/
  PREFERENCE = 4,
  /** 标签*/
  TAG = 5,
  /** 字符串 */
  STRING = 10,
  /**数字 */
  NUMBER = 11,
  /** 日期*/
  DATE = 12,
}

// 上传文件校验失败
export enum UploadUnvalidateEnum {
  /** 默认 */
  DEFAULT = '',
  /** 上传的文件类型不匹配 */
  UN_ACCEPT = 'unAccept',
  /** 超过最大上传文件个数 */
  OVER_MAX_NUM = 'overMaxNum',
  /** 上传的文件超过最大行数 */
  OVER_MAX_ROWS = 'overMaxRows',
  /** 超过最大上传文件size */
  OVER_MAX_SIZE = 'overMaxSize',
  /** 文件名超长 */
  OVER_MAX_NAME_LENGTH = 'overMaxNameLength',
  /** 表头异常 */
  HEADER_ERROR = 'headerError',
  /** 文件解码错误 */
  FILE_DECODE_ERROR = 'fileDecodeError',
  /** 文件内容为空 */
  IS_EMPTY = 'isEmpty',
  /** 删除空行过程失败 */
  DELETE_EMPTY_ROW_ERROR = 'deleteEmptyRowError',
  /** 单元格内容长度超限 */
  CELL_OVER_MAX_LENGTH = 'cellOverMaxLength',
}

// 手动添加单个联系人 - 系统字段key
export enum SystemKeyEnum {
  /** 邮箱 */
  EMAIL = 'email',
  /** 语言 */
  LANGUAGE = 'language',
  /** 地区 */
  LOCATION = 'location',
  /** 标签 */
  TAG = 'tag',
  /** 偏好 */
  PERFERENCE_ID = 'preferenceId',
}

// 地点编码
export enum LocationCodingEnum {
  /** 默认无编码 */
  DEFAULT = 0,
  /** 数字 */
  THREE_DIGIT_CODE = 1,
  /** 两位字母 */
  TWO_LETTER_CODE = 2,
  /** 三位字母 */
  THREE_LETTER_CODE = 3,
}

// csv导入联系人订阅状态配置
export enum subscribedStatusEnum {
  /** 已订阅 */
  SUBSCRIBED = 'subscribed',
  SUBSCRIBED_NUM_ONE = '1',
  SUBSCRIBED_NUM_TWO = '2',
  SUBSCRIBED_NUM_THREE = '3',
  /** 未订阅 */
  UN_SUBSCRIBED = 'unSubscribed',
  UN_SUBSCRIBED_NUM = '0',
  /** 未知 */
  NON_SUBSCRIBED = 'nonSubscribed',
  NON_SUBSCRIBED_NUM = '-1',
}

// csv导入联系人订阅状态子项
export enum subStatusOptEnum {
  /** 默认 */
  DEFAULT = 0,
  /** 更新 */
  UPDATE_SUBSCRIBED = 1,
  /**  更新部分 */
  UPDATE_PART_SUBSCRIBED = 3,
  /** 不更新 */
  UN_UPDATE_SUBSCRIBED = 2,
}

// 联系人 - 上报前端code
export enum ReportFeCodeEnum {
  CODE_100 = 100,
  CODE_101 = 101,
  CODE_102 = 102,
  CODE_103 = 103,
  CODE_104 = 104,
  CODE_105 = 105,
  CODE_106 = 106,
  CODE_107 = 107,
  CODE_108 = 108,
  CODE_109 = 109,
  CODE_110 = 110,
  CODE_111 = 111,
  CODE_112 = 112,
  CODE_113 = 113,
  CODE_114 = 114,
  CODE_115 = 115,
  CODE_116 = 116,
  CODE_117 = 117,
  CODE_118 = 118,
  CODE_119 = 119,
  CODE_120 = 120,
}

// CSV导入联系人 - 上报模块信息
export enum FormReportModuleNameEnum {
  /** 上传文件 */
  IMPORT_CONTACTS_UPLOAD_FILE = 'ImportContact(s)UploadFile',
  /** 标签 */
  IMPORT_CONTACTS_TAG = 'ImportContact(s)Tag',
  /** 检查 */
  IMPORT_CONTACTS_REVIEW = 'ImportContact(s)Review',
}

// 已开通Whatspp业务上传文件 - 订阅状态步骤
export enum SubscribeStatusStepTabEnum {
  // 邮箱
  EMAIL = 'email',
  // whatsApp
  WHATSAPP = 'whatsApp',
}

/** 上传文件 - 导入失败原因 */
export enum ImportErrorResource {
  /** 无效邮箱地址 - 邮箱为空 */
  EMAIL_NOT_FOUND = 'emailNotFound',
  /** 无效邮箱地址 - 格式错误 */
  EMAIL_WRONG_FORMAT = 'emailWrongFormat',
  /** 无效的地区编码 */
  INVALID_LOCATION_CODE = 'invalid location code',
  /** 无效的语言编码 */
  INVALID_LANGUAGE_CODE = 'invalid language code',
  /** 无效的偏好 */
  INVALID_PREFERENCE = 'invalid preference',
  /** 无效的标签 */
  INVALID_TAG = 'invalid tag',
  /** 标签个数超出限制 */
  INVALID_TAG_TOTAL = 'invalid tag total',
  /** 重复的邮箱地址 */
  EMAIL_DUPLICATED = 'duplicated email',
  /** 类型不匹配 */
  TYPE_MISMATCH = 'type mismatch',
  /** 无效的邮箱域名 */
  EMAIL_DOMAIN_ERROR = 'emailDomianError',
  /** 必填字段缺失（已开通WhatsApp业务：既无Email又无whatsApp） */
  NO_REQUIRE = 'noRequrie',
  /** 无效WhatsApp - 格式错误 */
  WHATSAPP_WRONG_FORMAT = 'whatsAppWrongFormat',
  /** 重复的WhatsApp */
  WHATSAPP_DUPLICATED = 'duplicated whatsApp',
  /** 自定义字段Dropdown类型数据 - 无效的{name} */
  INVALID_CUSTOM_DROP_DOWN = 'customFiledDropDownWrongFormat',
  /** 自定义字段非Dropdown类型数据 - 格式错误 */
  INVALID_CUSTOM_OTHER = 'customFiledWrongFormat',
}